import { gql } from '@apollo/client'

export const SEARCH_ARTIST_PRODUCTS = gql`
  query ($artistId: String!, $productName: String!, $configuration: ArtistProductType!, $useExtendedSearch: Boolean) {
    searchArtistProducts(
      artistId: $artistId
      productName: $productName
      configuration: $configuration
      useExtendedSearch: $useExtendedSearch
    ) {
      total
      products {
        dv_entity_id
        dv_group_id
        primaryArtistName
        name
        type
        release_date
      }
    }
  }
`
